import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import AuthLayout, { Field, SubmitBtn } from "./AuthLayout";

function formatError(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || String(e)).join(" ");
  return String(detail);
}

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await api.post("/auth/forgot-password", { email });
      toast.success("If an account exists, a code was sent to your email.");
      nav(`/verify-otp?email=${encodeURIComponent(email.toLowerCase().trim())}&purpose=reset`);
    } catch (e) {
      setErr(formatError(e?.response?.data?.detail || e.message));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="Enter your email. We'll send a 6-digit code."
      footer={
        <>
          Remembered it?{" "}
          <Link to="/login" className="font-semibold text-lm-primary hover:text-lm-primaryHover underline underline-offset-4">
            Sign in
          </Link>
        </>
      }
    >
      <form onSubmit={submit} data-testid="forgot-form">
        <Field label="Email" id="forgot-email" name="email" type="email" required autoComplete="email"
          placeholder="you@company.com" value={email} onChange={(e) => setEmail(e.target.value)}
          data-testid="forgot-email" />
        {err && <div className="mb-3 rounded-md bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">{err}</div>}
        <SubmitBtn loading={busy} data-testid="forgot-submit">Send reset code</SubmitBtn>
      </form>
    </AuthLayout>
  );
}
